import React, { useState, useEffect } from "react";
import Preloader from "../src/components/Pre";
import Navbar from "./components/Navbar";
import Home from "./components/Home/Home";
import Footer from "./components/Footer";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate
} from "react-router-dom";
import "./style.css";
import "./App_head.css";
import "bootstrap/dist/css/bootstrap.min.css";

import Auth from "./components/Auth";  // Обновите импорт с auth на Auth
import AppVkos from "./App_vkos"; // Импортируем новый компонент

function App() {
  const [load, updateLoad] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      updateLoad(false);
    }, 1200);

    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    
    const session = JSON.parse(localStorage.getItem('session'));
    
    if (session && session.userId && session.token) {
      setIsAuthenticated(true); // Если сессия существует, пользователь авторизован
    } else {
      setIsAuthenticated(false); // Если сессия не существует, пользователь не авторизован
    }
    
    
    
  }, []); // Эта проверка сработает при монтировании компонента

  return (
    <Router>
      <Preloader load={load} />
      <div className="App" id={load ? "no-scroll" : "scroll"}>
        <Navbar />
        <Routes>
          {/* Если пользователь авторизован, показываем AppVkos, иначе – главную страницу */}
          <Route path="/" element={isAuthenticated ? <AppVkos /> : <Home />} />
          <Route path="/auth" element={<Auth />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
